<!-- Contenet page started-->
<div class="row">
  <div class="privacy_policy_content">
    <div class="row">
      <div class="privacy_policy_logo">
        <img src="../../assets/img/new_dasboard_imges/loginbluvbay.png" height="57" width="165"/>
      </div>
    </div>
    <div class="row">
      <div class="policy_heading">
        <h2>PRIVACY POLICY</h2>
      </div>
    </div>
    <div class="row">
      <div class="privacy_content">
        <p>Blubay operates Blubay website <a href="https://www.aqucloud.com"
                                             target="_blank">(https://www.aqucloud.com)</a> in conjunction to, two
          mobile application (BluBay
          and Ambro AQU). This page informs you of our policies regarding the collection, use and disclosure of
          Personal Information we receive from our users of the site.
        </p>
        <p>We use your Personal Information only for providing and improving the site. By using the Site, you agree to
          the collection and information in accordance with this policy.
          Please read this privacy policy carefully. By visiting our Website you are accepting and consenting to the
          practices described in this policy. If you do not agree with the terms of this privacy policy, please do not
          access our Website.
        </p>
        <p class="marginspace">We reserve the right to make changes to this Privacy Policy at any time and for any
          reason. We will alert
          you about any changes by updating the “Last Updated” date of this document. Any changes or modifications
          will be effective immediately upon posting the updated Privacy Policy on our Website, and you waive the
          right to receive specific notice of each such change or modification. You are encouraged to periodically
          review this Privacy Policy to stay informed of updates. You will be deemed to have been made aware of, will
          be subject to, and will be deemed to have accepted the changes in any revised Privacy Policy by your
          continued use of our Website after the date such revised Privacy Policy is posted.
        </p>

        <h4> Key Details</h4>
        <p> This website privacy policy describes how Blubay protects and makes use of the information you give the
          company when you use this website.</p>
        <p>If you are asked to provide information when using this website, it will only be used in the ways described
          in this privacy policy.
        </p>
        <p>This policy is updated from time to time. The latest version is published on this page.</p>
        <p> This website privacy policy was updated on: 00/00/0000</p>
        <p class="marginspace"> If you have any questions about this policy, please email <a>info@ambrotechs.com</a> or
          mail us
          at:
          H.No.8-2-248/A/B, Ground Floor, and Road No.3, Land Mark: Chutney's, Banjara Hills, and Hyderabad – 500034
        </p>
        <h4>Introduction</h4>
        <p class="marginspace">While using our site, we may ask you to provide us with certain personally identifiable
          information may
          include, but is not limited to your name (‘Personal Information’).
          We may collect personal information, such as your name, job title, professional email address and professional
          telephone number, and demographic information such as your gender and interests, that you voluntarily give to
          us when you choose to participate in various activities related to our Website, such as online forms and
          surveys. You are under no obligation to provide us with personal information of any kind, however your refusal
          to do so may prevent you from using certain features of our Website.
        </p>
        <h4>Derivative Data</h4>
        <p class="marginspace">Like any other site operators, we collect information that your browser sends whenever
          you visit our site.
          This Log data may include information such as Computers Internet Protocol (IP) address, browser type, browser
          version, and the pages of our site that you visit, the time and date of your visit, the time spent on those
          pages and other statics.
        </p>
        <h4>Data from Social Networks</h4>
        <p class="marginspace">We may collect user information from social networking sites, such as Facebook, YouTube,
          LinkedIn, and
          Twitter, including your name, your social network username, location, gender, birth date, email address,
          profile picture, and public data for contacts - if you connect to and interact with us through such social
          networks.
        </p>


        <h4>Data We Gather</h4>
        <ul class="privacy_datawegather">
          <li> Name and Job title</li>
          <li>Contact Information including Email address</li>
          <li>Demographic information, such as postcode, preferences and interest</li>
          <li>Website usage data</li>
          <li>Other information relevant to client enquiries.</li>
          <li>Other information pertaining to special offers and surveys</li>
        </ul>

        <h4>Communications</h4>
        <p>We may use your Personal Information to contact you with newsletter, marketing or promotional materials and
          other information.
        </p>
        <h4 class="privacy_info">Use of your information</h4>
        <p>We strive to provide you with an excellent service. Having accurate information about you allows us to
          provide
          you with a smooth, efficient, and customized experience. Specifically, we may use information collected about
          you via our Website to:
        </p>
        <ul>
          <li>Customize and improve our products and service offering, and/or recommendations to you.</li>
          <li>Increase the efficiency and operation of our Website according to your interests.</li>
          <li>Notify you of updates to our Website.</li>
          <li>Respond to product and customer service requests.</li>
          <li>Resolve disputes and troubleshoot problems.</li>
          <li>Request feedback and contact you about your use of our Website.</li>
          <li>Send promotional emails about new products, special offers or other information which we think you may
            find
            interesting using the email address which you have provided.
          </li>
          <li>Deliver targeted advertising and other information regarding promotions and our Website to you.</li>
          <li>Create and manage your account.</li>
          <li>Email you regarding your account or order.</li>
          <li>Contact you by email, phone, fax or mail for market research purposes.</li>
          <li>Administer promotions and contests.</li>
          <li>Compile anonymous statistical data and analysis for use internally or with third parties.</li>
          <li>Monitor and analyze usage and trends to improve your experience with our Website.</li>
          <li>Perform other business activities as needed.</li>
        </ul>
        <h4 class="privacy_info">Tracking technologies</h4>
        <h4>Cookies</h4>
        <p>We may use cookies to help customize and improve your experience on our Website. You may adjust the settings
          on your browser to refuse cookies but be aware that such action could affect the availability and
          functionality on our Website.
        </p>
        <p>A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree,
          the
          file is added and the cookie helps analyze web traffic or lets you know when you visit a particular site.
          Cookies allow web applications to respond to you as an individual. The web application can tailor its
          operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
          We use traffic log cookies to identify which pages are being used. This helps us analyze data about web page
          traffic and improve our website in order to tailor it to customer needs. We only use this information for
          statistical analysis purposes and then the data is removed from the system.
        </p>
        <p>Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find
          useful and which you do not. A cookie in no way gives us access to your computer or any information about you,
          other than the data you choose to share with us.
        </p>
        <p class="marginspace">For more information on how we use cookies, please refer to our Cookie Policy posted on
          our Website, which is
          incorporated into this Privacy Policy. By using our Website, you agree to be bound by our Cookie Policy.
        </p>
        <h4>Website Analytics</h4>
        <p class="marginspace">We may also partner with selected third-party vendors such as Google Analytics to allow
          tracking technologies
          and remarketing services on our Website through the use of first party cookies and third-party cookies, to,
          among other things, analyze and track users’ use of our Website, determine the popularity of certain content
          and better understand online activity. By accessing our Website you consent to the collection and use of your
          information by these third- party vendors. You are encouraged to review their privacy policy and contact them
          directly for responses to your questions. We do not transfer personal information to these third-party
          vendors.
          You should be aware that getting a new computer, installing a new browser, upgrading an existing browser, or
          erasing or otherwise altering your browser’s cookies files may also clear certain opt-out cookies, plug-ins,
          or settings.
        </p>
        <h4 class="privacy_info">Disclosure of your information</h4>
        <p>We may share information we have collected about you in certain situations. Your information may be disclosed
          as follows:
        </p>
        <h4>By Law or to Protect Rights</h4>
        <p>If we believe the release of information about you is necessary to respond to legal process, to investigate
          or
          remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may
          share your information as permitted or required by any applicable law, rule, or regulation. This includes
          exchanging information with other entities for fraud protection and credit risk reduction.
        </p>
        <h4>Business Partners</h4>
        <p>We may share your information with our business partners, suppliers and sub-contractors for the performance
          of
          any contract we enter into with them or you.
        </p>
        <h4>Online Postings</h4>
        <p>When you post comments, contributions or other content to our Website, your posts may be viewed by all users
          and may be publicly distributed outside our Website in perpetuity.
        </p>
        <h4>Storage</h4>
        <p class="marginspace">Your personal data will not be retained longer than necessary, and only in relation to
          the purpose for which
          such it is processed. When the data is no longer needed or goes out of date, it is deleted from our systems.
          In certain cases, the data is securely archived to allow legal requirements or agreed industry practices. No
          data is held any more than 6 years.
        </p>
        <h4 class="privacy_info">Security of your information</h4>
        <p class="marginspace">We use administrative, technical, and physical security measures to help protect your
          personal data. While we
          have taken reasonable steps to secure the personal information you provide to us, please be aware that despite
          our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be
          guaranteed against any interception or other type of misuse.
        </p>
        <h4 class="privacy_info">Determining and Sharing Location</h4>
        <p>Determining your location – The services deal with location, so in order to work, the services need to know
          your location. Whenever you open and use/interact with the app on your mobile device or go onto one of our
          sites. We use the location information from your mobile device or browser (e.g., latitude and longitude) to
          tailor the Services experience to your current location (i.e. we’ll show you a list of nearby locations and
          tips). This information is NOT shared with others. Also, the services use your mobile device’s background
          location’ to provide the services, including to send you notifications. If you have background location turned
          on, the foursquare app will, from time to time, tell us about your device’s location even if you are not
          directly interacting with the application.
        </p>
        <h4 class="privacy_info">Policy for children</h4>
        <p class="marginspace">We do not knowingly solicit information from or market to children under the age of 16.
          If you become aware
          of any data we have collected from children under age 16, please contact us using the contact information
          provided below.
        </p>
        <h4 class="privacy_info">Options regarding your information</h4>
        <h4>Account Information</h4>
        <p>You may at any time review or change the information in your account or terminate your account by:</p>
        <ul>
          <li>Contacting us through our Website’s online form <a href="https://www.ambrotechs.com/contact-us"
                                                                 target="_blank">https://www.ambrotechs.com/contact-us</a>
          </li>
          <li>Writing us at <a>info@ambrotechs.com</a></li>
        </ul>
        <h4>Emails and Communications</h4>
        <p>If you no longer wish to receive correspondence, emails, or other communications from us, you may opt-out
          by:</p>
        <ul>
          <li>Noting your preferences at the time you receive the communication</li>
          <li>Contacting us at <a>info@ambrotechs.com</a></li>
        </ul>
        <p class="marginspace">If you no longer wish to receive correspondence, emails, or other communications from
          third parties, you are
          responsible for contacting the third party directly.
        </p>

        <h4 class="privacy_info">You’re right to control and access your personal information</h4>

        <p class="marginspace">If at any point you believe the information we process on you is incorrect you can
          request to see this
          information, and have it corrected or deleted. If you wish to raise a complaint on how we have handled your
          personal data, you can contact us to have the matter investigated <a>communications@ambrotechs.com</a>
        </p>
        <h4 class="privacy_info">Contact us</h4>
        <p>If you have questions or comments about this Privacy Policy, please contact us at: <a>info@ambrotechs.com</a></p>


      </div>
    </div>
  </div>
</div>
